import {
	Card,
	CardContent,
	CircularProgress,
	Typography,
} from "@material-ui/core";
import { useTableStyles } from "../../styles/useTableStyles";
interface Props {
	assetId: number;
	assetName: string;
}
export const AssetCard = ({ assetId, assetName }: Props) => {
	const classes = useTableStyles();
	const colors: { [assetId: number]: string } = {
		15: "#479dc4",
		11: "#dae8fc",
		12: "#d5e8d4",
		13: "#f4d2d2",
	};

	return (
		<>
			<Card
				className={classes.assetTitle}
				style={{
					backgroundColor: assetId ? colors[assetId] : " #e0e0e0",
					color: assetId === 15 ? "white" : "black",
				}}
				variant="outlined"
			>
				<CardContent>
					{assetId && assetName ? (
						<Typography variant="h3">{assetName}</Typography>
					) : (
						<CircularProgress />
					)}
				</CardContent>
			</Card>
		</>
	);
};
